export let allYears = [
  { key: '1', value: '2022' },
  { key: '2', value: '2023' },
  { key: '3', value: '2024' },
]
export let allRegions = [
  { key: '1', value: 'region 1' },
  { key: '2', value: 'region 2' },
  { key: '3', value: 'region 3' },
]

export let dataSourcesMocked = {
  results: [
    {
      id: 64,
      name: 'SullivanCotter Physician',
      year: 2020,
      region: 'National',
      standardJob: 'Allergy and Immunology',
      calculations: [
        {
          variable: 'TCC',
          incumbentCount: 336,
          unitType: '$',
          percentiles: {
            50: 313676.84375,
            55: 321543.25,
            60: 333817.78125,
            65: 348392.5625,
            75: 375108.71875,
          },
          calculatedPercentile: 90,
        },
        {
          variable: 'Work RVUs',
          incumbentCount: 210,
          unitType: '$',
          percentiles: {
            25: 3333.190673828125,
            50: 4296.9248046875,
            55: 4455.203125,
            60: 4659.8720703125,
            65: 4874.10986328125,
          },
          calculatedPercentile: 78,
        },
      ],
    },
    {
      id: 64,
      name: 'MGMA Physician',
      year: 2020,
      region: 'National',
      standardJob: 'Allergy and Immunology',
      calculations: [
        {
          variable: 'TCC',
          incumbentCount: 336,
          unitType: '$',
          percentiles: {
            10: 198038.484375,
            25: 251234.71875,
            50: 313676.84375,
            55: 321543.25,
            60: 333817.78125,
            65: 348392.5625,
            75: 375108.71875,
            90: 480054.65625,
          },
          calculatedPercentile: 89,
        },
        {
          variable: 'Work RVUs',
          incumbentCount: 210,
          unitType: '$',
          percentiles: {
            50: 4296.9248046875,
            55: 4455.203125,
            60: 4659.8720703125,
            65: 4874.10986328125,
            75: 5476.49267578125,
            90: 6666.89404296875,
          },
          calculatedPercentile: 0.5,
        },
      ],
    },
    {
      id: 64,
      name: 'Large Clinic Physician',
      year: 2020,
      region: 'National',
      standardJob: 'Allergy and Immunology',
      calculations: [
        {
          variable: 'TCC',
          incumbentCount: 336,
          unitType: '$',
          percentiles: {
            10: 198038.484375,
            25: 251234.71875,
            50: 313676.84375,
            55: 321543.25,
            60: 333817.78125,
            65: 348392.5625,
          },
          calculatedPercentile: 65,
        },
        {
          variable: 'Work RVUs',
          incumbentCount: 210,
          unitType: '$',
          percentiles: {
            10: 2595.699951171875,
            25: 3333.190673828125,
            50: 4296.9248046875,
            55: 4455.203125,
            60: 4659.8720703125,
            65: 4874.10986328125,
            75: 5476.49267578125,
            90: 6666.89404296875,
          },
          calculatedPercentile: 0.9,
        },
      ],
    },
    {
      id: 64,
      name: 'MGMA Management and Staff',
      year: 2020,
      region: 'National',
      standardJob: 'Allergy and Immunology',
      calculations: [
        {
          variable: 'TCC',
          incumbentCount: 336,
          unitType: '$',
          percentiles: {
            10: 198038.484375,
            25: 251234.71875,
            50: 313676.84375,
            55: 321543.25,
            60: 333817.78125,
            65: 348392.5625,
            75: 375108.71875,
            90: 480054.65625,
          },
          calculatedPercentile: 66,
        },
        {
          variable: 'Work RVUs',
          incumbentCount: 210,
          unitType: '$',
          percentiles: {
            10: 2595.699951171875,
            25: 3333.190673828125,
            50: 4296.9248046875,
            55: 4455.203125,
            60: 4659.8720703125,
            65: 4874.10986328125,
            75: 5476.49267578125,
            90: 6666.89404296875,
          },
          calculatedPercentile: 33,
        },
      ],
    },
  ],
}

export let dataSourcesExamples = {
  s1: {
    compensationValues: ['$234k', '$373k', '$553k', '$733k', '$949k'],
    compensation: 56,
    productivityValues: ['$148k', '$345k', '$588k', '$613k', '$822k'],
    productivity: 91,
  },
  m1: {
    compensationValues: ['$155k', '$244k', '$345k', '$589k', '$677k'],
    compensation: 67,
    productivityValues: ['$210k', '$279k', '$456k', '$673k', '$982k'],
    productivity: 86,
  },
  u1: {
    compensationValues: ['$199k', '$234k', '$511k', '$809k', '$912k'],
    compensation: 24,
    productivityValues: ['$212k', '$356k', '$478k', '$517k', '$888k'],
    productivity: 56,
  },
  c1: {
    compensationValues: ['$123k', '$263k', '$443k', '$623k', '$938k'],
    compensation: 22,
    productivityValues: ['$135k', '$335k', '$553k', '$631k', '$837k'],
    productivity: 33,
  },
}

export function getDataSourceMockedValues(key) {
  return dataSourcesExamples[key]
}

export const availableDataSourcesOptions = [
  {
    annual: [
      {
        id: 1,
        code: 'A',
        name: 'Health Care Staff',
        years: [
          {
            key: 139,
            year: 2022,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 27,
                name: 'West',
              },
              {
                id: 26,
                name: 'Southeast',
              },
            ],
          },
          {
            key: 204,
            year: 2023,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 27,
                name: 'West',
              },
              {
                id: 26,
                name: 'Southeast',
              },
            ],
          },
        ],
      },
      {
        id: 4,
        code: 'D',
        name: 'Large Clinic APP',
        years: [
          {
            key: 98,
            year: 2021,
            regions: [
              {
                id: 2,
                name: 'National',
              },
            ],
          },
          {
            key: 221,
            year: 2023,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 27,
                name: 'West',
              },
            ],
          },
        ],
      },
      {
        id: 5,
        code: 'E',
        name: 'MGMA Provider',
        years: [
          {
            key: 155,
            year: 2022,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 27,
                name: 'West',
              },
            ],
          },
        ],
      },
      {
        id: 6,
        code: 'F',
        name: 'Mercer Corporate Services Human Resources',
        years: [
          {
            key: 1856338590,
            year: 2022,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 26,
                name: 'Southeast',
              },
            ],
          },
          {
            key: 1101313654,
            year: 2023,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 26,
                name: 'Southeast',
              },
            ],
          },
        ],
      },
      {
        id: 6,
        code: 'G',
        name: 'Mercer Executive',
        years: [
          {
            key: 1321056127,
            year: 2022,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 23,
                name: 'North Central',
              },
            ],
          },
          {
            key: 1347889090,
            year: 2023,
            regions: [
              {
                id: 2,
                name: 'National',
              },
              {
                id: 26,
                name: 'Southeast',
              },
            ],
          },
        ],
      },
    ],
    custom: [],
    blend: [],
    purchased: [],
    uploaded: [],
  },
]

export const specialtiesMock = [
  {
    code: '3215',
    name: 'Account Manager - Associate',
  },
  {
    code: '3210',
    name: 'Account Manager - Senior',
  },
  {
    code: '1000',
    name: 'Allergy and Immunology',
  },
  {
    code: '2000',
    name: 'Anesthesiology',
  },
  {
    code: '2003',
    name: 'Anesthesiology - Cardiovascular',
  },
  {
    code: '2226',
    name: 'Anesthesiology - Neurocritical Care',
  },
  {
    code: '2230',
    name: 'Anesthesiology - Pain Medicine',
  },
  {
    code: '3000',
    name: 'Audiologist',
  },
  {
    code: '1007',
    name: 'Bariatric Medicine and Clinical Nutrition',
  },
  {
    code: '3020',
    name: 'Biochemistry',
  },
  {
    code: '3155',
    name: 'Broker Relations Representative - Intermediate',
  },
  {
    code: '3023',
    name: 'Cancer Biology',
  },
  {
    code: '1016',
    name: 'Cardiology - Advanced Heart Failure and Transplant',
  },
  {
    code: '1020',
    name: 'Cardiology - Cardiac Imaging (Echo, CT, MRI, Nuclear)',
  },
  {
    code: '1030',
    name: 'Cardiology - Electrophysiology',
  },
  {
    code: '1040',
    name: 'Cardiology - General',
  },
  {
    code: '1010',
    name: 'Cardiology - Invasive - Interventional',
  },
  {
    code: '1012',
    name: 'Cardiology - Invasive - Noninterventional',
  },
  {
    code: '2010',
    name: 'Cardiothoracic Surgery',
  },
  {
    code: '3027',
    name: 'Cellular and Molecular Biology',
  },
  {
    code: '3029',
    name: 'Certified Anesthesiologist Assistant',
  },
  {
    code: '3080',
    name: 'Certified Nurse Midwife',
  },
  {
    code: '3030',
    name: 'Certified Registered Nurse Anesthetist',
  },
  {
    code: '3033',
    name: 'Chemistry',
  },
  {
    code: '3211',
    name: 'Child Psychologist (PhD)',
  },
  {
    code: '3035',
    name: 'Chiropractor',
  },
  {
    code: '2070',
    name: 'Claims Quality Auditor - Senior',
  },
  {
    code: '3025',
    name: 'Clinical Nurse Specialist (RN)',
  },
  {
    code: '2020',
    name: 'Colon and Rectal Surgery',
  },
  {
    code: '3034',
    name: 'Computational Biology',
  },
  {
    code: '1060',
    name: 'Critical Care Medicine',
  },
  {
    code: '1055',
    name: 'Critical Care Medicine - Cardiology',
  },
  {
    code: '3040',
    name: 'Dentist',
  },
  {
    code: '1070',
    name: 'Dermatology',
  },
  {
    code: '1075',
    name: 'Dermatology - Cosmetic',
  },
  {
    code: '1090',
    name: 'Dermatology - Mohs Surgery',
  },
  {
    code: '2000',
    name: 'Director, Claims Processing',
  },
  {
    code: '2150',
    name: 'Director, Health Data Analysis',
  },
  {
    code: '2280',
    name: 'Director, Health Promotion/Education',
  },
  {
    code: '2015',
    name: 'Director, Member Service',
  },
  {
    code: '2030',
    name: 'Director, Membership Enrollment and Billing',
  },
  {
    code: '2190',
    name: 'Director, Provider Service',
  },
  {
    code: '3100',
    name: 'Director, Sales Support',
  },
  {
    code: '3090',
    name: 'Dosimetrist',
  },
  {
    code: '2030',
    name: 'Emergency Medicine',
  },
  {
    code: '2025',
    name: 'Endocrine Surgery',
  },
  {
    code: '1100',
    name: 'Endocrinology and Metabolism',
  },
  {
    code: '3053',
    name: 'Epidemiology',
  },
  {
    code: '1105',
    name: 'Epidemiology (MD)',
  },
  {
    code: '1110',
    name: 'Family Medicine',
  },
  {
    code: '1123',
    name: 'Family Medicine - Medical Home',
  },
  {
    code: '1115',
    name: 'Family Medicine With Obstetrics',
  },
  {
    code: '2275',
    name: 'Fraud Analyst/Investigator - Associate',
  },
  {
    code: '2270',
    name: 'Fraud Investigator - Senior',
  },
  {
    code: '1130',
    name: 'Gastroenterology',
  },
  {
    code: '1135',
    name: 'Gastroenterology - EUS/ERCP',
  },
  {
    code: '2050',
    name: 'General Surgery',
  },
  {
    code: '3054',
    name: 'Genetics',
  },
  {
    code: '1465',
    name: 'Genetics (MD)',
  },
  {
    code: '1150',
    name: 'Geriatrics',
  },
  {
    code: '2295',
    name: 'Health Promotion/Education Specialist - Associate',
  },
  {
    code: '2290',
    name: 'Health Promotion/Education Specialist - Senior',
  },
  {
    code: '1183',
    name: 'Hepatology',
  },
  {
    code: '1184',
    name: 'Hepatology - Transplant',
  },
  {
    code: '1317',
    name: 'Hospice and Palliative Medicine',
  },
  {
    code: '3109',
    name: 'Hospital Based Specialties - NP',
  },
  {
    code: '3179',
    name: 'Hospital Based Specialties - PA',
  },
  {
    code: '1192',
    name: 'Hospitalist - Extensivist',
  },
  {
    code: '1185',
    name: 'Hospitalist - Internal Medicine',
  },
  {
    code: '1245',
    name: 'Hospitalist - Laborist',
  },
  {
    code: '1193',
    name: 'Hospitalist - Neurology',
  },
  {
    code: '1260',
    name: 'Hospitalist - Nocturnist',
  },
  {
    code: '1500',
    name: 'Hyperbaric and Wound Care',
  },
  {
    code: '3060',
    name: 'Immunology',
  },
  {
    code: '1200',
    name: 'Infectious Disease',
  },
  {
    code: '3021',
    name: 'Inside Sales/Telemarketing Representative - Associate',
  },
  {
    code: '1202',
    name: 'Integrative Medicine',
  },
  {
    code: '1210',
    name: 'Internal Medicine',
  },
  {
    code: '1223',
    name: 'Internal Medicine - Medical Home',
  },
  {
    code: '3150',
    name: 'Manager, Broker Relations/Sales Channel',
  },
  {
    code: '2005',
    name: 'Manager, Claims Processing',
  },
  {
    code: '2285',
    name: 'Manager, Health Promotion/Education',
  },
  {
    code: '2020',
    name: 'Manager, Member Service',
  },
  {
    code: '2035',
    name: 'Manager, Membership Enrollment and Billing',
  },
  {
    code: '2250',
    name: 'Manager, Quality Management',
  },
  {
    code: '3113',
    name: 'Medical Specialties - NP',
  },
  {
    code: '3180',
    name: 'Medical Specialties - PA',
  },
  {
    code: '2027',
    name: 'Member Service Representative - Intermediate',
  },
  {
    code: '3070',
    name: 'Microbiology',
  },
  {
    code: '1485',
    name: 'Nephrology - Transplant',
  },
  {
    code: '1191',
    name: 'Nephrology Only',
  },
  {
    code: '1190',
    name: 'Nephrology and Hypertension',
  },
  {
    code: '2090',
    name: 'Neurological Surgery',
  },
  {
    code: '2096',
    name: 'Neurological Surgery - Neurocritical Care',
  },
  {
    code: '2094',
    name: 'Neurological Surgery - Spine',
  },
  {
    code: '2093',
    name: 'Neurological Surgery - Vascular',
  },
  {
    code: '1250',
    name: 'Neurology',
  },
  {
    code: '1252',
    name: 'Neurology - Epilepsy',
  },
  {
    code: '4085',
    name: 'Neurology - Interventional',
  },
  {
    code: '1254',
    name: 'Neurology - Multiple Sclerosis',
  },
  {
    code: '1195',
    name: 'Neurology - Neurocritical Care',
  },
  {
    code: '1253',
    name: 'Neurology - Neuromuscular',
  },
  {
    code: '1255',
    name: 'Neurology - Vascular',
  },
  {
    code: '3075',
    name: 'Neurophysiology',
  },
  {
    code: '3215',
    name: 'Neuropsychology (PhD)',
  },
  {
    code: '3073',
    name: 'Neuroscience',
  },
  {
    code: '2243',
    name: 'Nurse Quality Auditor',
  },
  {
    code: '3118',
    name: 'Nutritionist (Non-MD)',
  },
  {
    code: '2070',
    name: 'Obstetrics/Gynecology - General',
  },
  {
    code: '1160',
    name: 'Obstetrics/Gynecology - Gynecologic Oncology',
  },
  {
    code: '1170',
    name: 'Obstetrics/Gynecology - Gynecology Only',
  },
  {
    code: '1420',
    name: 'Obstetrics/Gynecology - Maternal and Fetal Medicine',
  },
  {
    code: '1460',
    name: 'Obstetrics/Gynecology - Reproductive Endocrinology and Infertility',
  },
  {
    code: '2075',
    name: 'Obstetrics/Gynecology - Urogynecology',
  },
  {
    code: '3120',
    name: 'Occupational Therapist',
  },
  {
    code: '1280',
    name: 'Occupational and Environmental Medicine',
  },
  {
    code: '1178',
    name: 'Oncology - Bone Marrow Transplant',
  },
  {
    code: '1176',
    name: 'Oncology - Breast',
  },
  {
    code: '1180',
    name: 'Oncology - Hematology and Oncology',
  },
  {
    code: '1179',
    name: 'Oncology - Immunotherapy',
  },
  {
    code: '1181',
    name: 'Oncology - Medical Oncology',
  },
  {
    code: '1182',
    name: 'Oncology - Melanoma and Sarcoma',
  },
  {
    code: '1188',
    name: 'Oncology - Neuro-Oncology',
  },
  {
    code: '2115',
    name: 'Ophthalmology - Cornea and External Disease',
  },
  {
    code: '2100',
    name: 'Ophthalmology - General',
  },
  {
    code: '2117',
    name: 'Ophthalmology - Glaucoma',
  },
  {
    code: '1315',
    name: 'Ophthalmology - Medical',
  },
  {
    code: '1230',
    name: 'Ophthalmology - Medical Retina',
  },
  {
    code: '1235',
    name: 'Ophthalmology - Neuro-Ophthalmology',
  },
  {
    code: '2097',
    name: 'Ophthalmology - Oculoplastic Surgery',
  },
  {
    code: '2111',
    name: 'Ophthalmology - Oncology',
  },
  {
    code: '2120',
    name: 'Ophthalmology - Orbital',
  },
  {
    code: '2105',
    name: 'Ophthalmology - Refractive Surgery',
  },
  {
    code: '2130',
    name: 'Ophthalmology - Vitreoretinal Surgery',
  },
  {
    code: '3130',
    name: 'Optometrist',
  },
  {
    code: '2135',
    name: 'Oral and Maxillofacial Surgery',
  },
  {
    code: '3042',
    name: 'Orthodontics',
  },
  {
    code: '2175',
    name: 'Orthopedic Surgery - Foot and Ankle',
  },
  {
    code: '2150',
    name: 'Orthopedic Surgery - General',
  },
  {
    code: '2170',
    name: 'Orthopedic Surgery - Hand',
  },
  {
    code: '2180',
    name: 'Orthopedic Surgery - Hip and Knee',
  },
  {
    code: '1310',
    name: 'Orthopedic Surgery - Medical',
  },
  {
    code: '2145',
    name: 'Orthopedic Surgery - Oncology',
  },
  {
    code: '2185',
    name: 'Orthopedic Surgery - Shoulder and Elbow',
  },
  {
    code: '2190',
    name: 'Orthopedic Surgery - Spine',
  },
  {
    code: '2280',
    name: 'Orthopedic Surgery - Sports Medicine',
  },
  {
    code: '2213',
    name: 'Otolaryngology - Facial Plastic and Reconstructive Surgery',
  },
  {
    code: '2210',
    name: 'Otolaryngology - General',
  },
  {
    code: '2215',
    name: 'Otolaryngology - Head and Neck',
  },
  {
    code: '2212',
    name: 'Otolaryngology - Otology and Neurotology',
  },
  {
    code: '2214',
    name: 'Otolaryngology - Rhinology',
  },
  {
    code: '1437',
    name: 'Pain Medicine - Non-Anesthesiology',
  },
  {
    code: '3150',
    name: 'Pathology',
  },
  {
    code: '2270',
    name: 'Pathology - Anatomic',
  },
  {
    code: '4100',
    name: 'Pathology - Anatomic and Clinical',
  },
  {
    code: '4101',
    name: 'Pathology - Blood Banking and Transfusion Medicine',
  },
  {
    code: '4103',
    name: 'Pathology - Clinical',
  },
  {
    code: '4104',
    name: 'Pathology - Cytopathology',
  },
  {
    code: '4010',
    name: 'Pathology - Dermatopathology',
  },
  {
    code: '4070',
    name: 'Pathology - Microbiology',
  },
  {
    code: '4075',
    name: 'Pathology - Molecular Genetic',
  },
  {
    code: '4077',
    name: 'Pathology - Stem Cell Therapy',
  },
  {
    code: '4107',
    name: 'Pathology - Surgical',
  },
  {
    code: '3137',
    name: 'Pathology Assistant',
  },
  {
    code: '3041',
    name: 'Pediatric Dentist',
  },
  {
    code: '1325',
    name: 'Pediatrics - Adolescent Medicine',
  },
  {
    code: '1330',
    name: 'Pediatrics - Allergy and Immunology',
  },
  {
    code: '4005',
    name: 'Pediatrics - Anesthesiology',
  },
  {
    code: '1418',
    name: 'Pediatrics - Bone Marrow Transplant',
  },
  {
    code: '1350',
    name: 'Pediatrics - Cardiology',
  },
  {
    code: '1352',
    name: 'Pediatrics - Cardiology - Interventional',
  },
  {
    code: '2241',
    name: 'Pediatrics - Cardiothoracic Surgery',
  },
  {
    code: '1384',
    name: 'Pediatrics - Critical Care Medicine',
  },
  {
    code: '1056',
    name: 'Pediatrics - Critical Care Medicine - Cardiology',
  },
  {
    code: '1085',
    name: 'Pediatrics - Dermatology',
  },
  {
    code: '1355',
    name: 'Pediatrics - Developmental-Behavioral Medicine',
  },
  {
    code: '1360',
    name: 'Pediatrics - Endocrinology',
  },
  {
    code: '1370',
    name: 'Pediatrics - Gastroenterology',
  },
  {
    code: '1320',
    name: 'Pediatrics - General',
  },
  {
    code: '2240',
    name: 'Pediatrics - General Surgery',
  },
  {
    code: '1375',
    name: 'Pediatrics - Genetics',
  },
  {
    code: '1377',
    name: 'Pediatrics - Gynecology',
  },
  {
    code: '1380',
    name: 'Pediatrics - Hematology and Oncology',
  },
  {
    code: '1187',
    name: 'Pediatrics - Hospitalist',
  },
  {
    code: '1382',
    name: 'Pediatrics - Infectious Disease',
  },
  {
    code: '1386',
    name: 'Pediatrics - Internal Medicine',
  },
  {
    code: '1240',
    name: 'Pediatrics - Neonatal-Perinatal Medicine',
  },
  {
    code: '1390',
    name: 'Pediatrics - Nephrology',
  },
  {
    code: '2095',
    name: 'Pediatrics - Neurological Surgery',
  },
  {
    code: '1400',
    name: 'Pediatrics - Neurology',
  },
  {
    code: '2250',
    name: 'Pediatrics - Ophthalmology',
  },
  {
    code: '2200',
    name: 'Pediatrics - Orthopedic Surgery',
  },
  {
    code: '2205',
    name: 'Pediatrics - Otolaryngology',
  },
  {
    code: '1385',
    name: 'Pediatrics - Pain Medicine - Non-Anesthesiology',
  },
  {
    code: '1387',
    name: 'Pediatrics - Palliative Care',
  },
  {
    code: '4105',
    name: 'Pediatrics - Pathology',
  },
  {
    code: '4108',
    name: 'Pediatrics - Physical Medicine and Rehabilitation',
  },
  {
    code: '2265',
    name: 'Pediatrics - Plastic and Reconstructive Surgery',
  },
  {
    code: '1410',
    name: 'Pediatrics - Pulmonology',
  },
  {
    code: '4045',
    name: 'Pediatrics - Radiology',
  },
  {
    code: '1415',
    name: 'Pediatrics - Rheumatology',
  },
  {
    code: '1416',
    name: 'Pediatrics - Sports Medicine - Medical',
  },
  {
    code: '1417',
    name: 'Pediatrics - Urgent Care',
  },
  {
    code: '2335',
    name: 'Pediatrics - Urology',
  },
  {
    code: '3155',
    name: 'Perfusionist',
  },
  {
    code: '3020',
    name: 'PhD-Only Clinician or Researcher - Biochemistry',
  },
  {
    code: '3027',
    name: 'PhD-Only Clinician or Researcher - Cellular and Molecular Biology',
  },
  {
    code: '3034',
    name: 'PhD-Only Clinician or Researcher - Computational Biology',
  },
  {
    code: '3053',
    name: 'PhD-Only Clinician or Researcher - Epidemiology',
  },
  {
    code: '3054',
    name: 'PhD-Only Clinician or Researcher - Genetics',
  },
  {
    code: '3070',
    name: 'PhD-Only Clinician or Researcher - Microbiology',
  },
  {
    code: '3073',
    name: 'PhD-Only Clinician or Researcher - Neuroscience',
  },
  {
    code: '3150',
    name: 'PhD-Only Clinician or Researcher - Pathology',
  },
  {
    code: '3221',
    name: 'PhD-Only Clinician or Researcher - Pharmacology',
  },
  {
    code: '3225',
    name: 'PhD-Only Clinician or Researcher - Statistics',
  },
  {
    code: '3160',
    name: 'Pharmacist (RPh)',
  },
  {
    code: '3221',
    name: 'Pharmacology',
  },
  {
    code: '1430',
    name: 'Physical Medicine and Rehabilitation',
  },
  {
    code: '1505',
    name: 'Physical Medicine and Rehabilitation - Interventional Pain Management',
  },
  {
    code: '3170',
    name: 'Physical Therapist',
  },
  {
    code: '3050',
    name: 'Physics - Diagnostic Radiology',
  },
  {
    code: '3055',
    name: 'Physics - Imaging',
  },
  {
    code: '3100',
    name: 'Physics - Nuclear Medicine',
  },
  {
    code: '3220',
    name: 'Physics - Radiation Oncology',
  },
  {
    code: '2260',
    name: 'Plastic and Reconstructive Surgery',
  },
  {
    code: '2262',
    name: 'Plastic and Reconstructive Surgery - Hand',
  },
  {
    code: '3195',
    name: 'Podiatry - Medical',
  },
  {
    code: '3190',
    name: 'Podiatry - Surgical',
  },
  {
    code: '1112',
    name: 'Primary Care - Rural Emergency Department',
  },
  {
    code: '3182',
    name: 'Primary Care Specialties - PA',
  },
  {
    code: '1005',
    name: 'Psychiatry - Addiction Psychiatry',
  },
  {
    code: '1445',
    name: 'Psychiatry - Child and Adolescent',
  },
  {
    code: '1443',
    name: 'Psychiatry - Consult Liaison',
  },
  {
    code: '1440',
    name: 'Psychiatry - General',
  },
  {
    code: '1446',
    name: 'Psychiatry - Geriatrics',
  },
  {
    code: '1441',
    name: 'Psychiatry - Inpatient',
  },
  {
    code: '1448',
    name: 'Psychiatry - Neuropsychiatry',
  },
  {
    code: '1442',
    name: 'Psychiatry - Outpatient',
  },
  {
    code: '3212',
    name: 'Psychologist (MS)',
  },
  {
    code: '3210',
    name: 'Psychologist (PhD)',
  },
  {
    code: '1451',
    name: 'Pulmonology - Critical Care Medicine',
  },
  {
    code: '1450',
    name: 'Pulmonology - General',
  },
  {
    code: '1452',
    name: 'Pulmonology - Without Critical Care or Sleep Medicine',
  },
  {
    code: '2260',
    name: 'Quality Management Analyst - Associate',
  },
  {
    code: '4040',
    name: 'Radiology - Diagnostic',
  },
  {
    code: '4030',
    name: 'Radiology - Interventional',
  },
  {
    code: '1175',
    name: 'Radiology - Mammography',
  },
  {
    code: '4020',
    name: 'Radiology - Neurointerventional',
  },
  {
    code: '4080',
    name: 'Radiology - Nuclear Medicine',
  },
  {
    code: '4130',
    name: 'Radiology - Radiation Oncology',
  },
  {
    code: '1470',
    name: 'Rheumatology',
  },
  {
    code: '3115',
    name: 'Sales Support Specialist',
  },
  {
    code: '2050',
    name: 'Senior Director, Health Plan Operations',
  },
  {
    code: '1472',
    name: 'Skilled Nursing Facility Provider',
  },
  {
    code: '1475',
    name: 'Sleep Medicine',
  },
  {
    code: '3230',
    name: 'Social Worker',
  },
  {
    code: '3235',
    name: 'Speech Pathologist',
  },
  {
    code: '1480',
    name: 'Sports Medicine - Medical',
  },
  {
    code: '3225',
    name: 'Statistics',
  },
  {
    code: '2007',
    name: 'Supervisor, Claims Processing',
  },
  {
    code: '2264',
    name: 'Surgical Critical Care',
  },
  {
    code: '2098',
    name: 'Surgical Oncology - General',
  },
  {
    code: '2099',
    name: 'Surgical Oncology - Thoracic',
  },
  {
    code: '3001',
    name: 'Surgical Oncology - Urology',
  },
  {
    code: '3117',
    name: 'Surgical Specialties - NP',
  },
  {
    code: '3185',
    name: 'Surgical Specialties - PA',
  },
  {
    code: '1270',
    name: 'Top Actuarial Executive',
  },
  {
    code: '2296',
    name: 'Transplant Surgery - General',
  },
  {
    code: '2300',
    name: 'Transplant Surgery - Kidney',
  },
  {
    code: '2310',
    name: 'Transplant Surgery - Liver',
  },
  {
    code: '2292',
    name: 'Transplant Surgery - Medical',
  },
  {
    code: '2290',
    name: 'Transplant Surgery - Thoracic',
  },
  {
    code: '2008',
    name: 'Trauma Surgery - Burn',
  },
  {
    code: '1490',
    name: 'Urgent Care',
  },
  {
    code: '2320',
    name: 'Urology',
  },
  {
    code: '2340',
    name: 'Vascular Surgery',
  },
]

export function sortDataSources(dataSources) {
  const order = { 'Annual Survey': 1, 'Standard Module': 2, 'Upgrade Module': 3, 'Custom Module': 4 }

  return dataSources.slice().sort((a, b) => {
    return order[a.type] - order[b.type] || a.value.localeCompare(b.value)
  })
}

export const sortSurveysByName = surveys => {
  if (!surveys) {
    return []
  }
  return surveys.sort((a, b) => a.name.localeCompare(b.name))
}

export const addPropertiesToSurveys = (surveys, properties) => {
  return surveys.map(survey => ({
    ...survey,
    ...properties,
  }))
}

export const calculatePercentileResponseMock = {
  results: [
    {
      id: 139,
      name: 'Health Care Staff',
      year: 2022,
      region: 'Southeast',
      calculations: [
        {
          variable: 'TCC - Hourly',
          incumbentCount: 381,
          unitType: '$',
          percentiles: {
            10: 79373,
            25: 85883,
            50: 94598,
            55: 95930,
            60: 98363,
            65: 99382,
            75: 103168,
            90: 106683,
          },
          calculatedPercentile: 33.242,
        },
      ],
    },
    {
      id: 155,
      name: 'MGMA Provider',
      year: 2022,
      region: 'Southeast',
      calculations: [
        {
          variable: 'TCC',
          incumbentCount: 58,
          unitType: '$',
          percentiles: {
            10: 76666,
            25: 85239,
            50: 98693,
            55: 100515,
            60: 105002,
            65: 107634,
            75: 112153,
            90: 163122,
          },
          calculatedPercentile: 31.351,
        },
        {
          variable: 'Work RVUs',
          incumbentCount: 38,
          unitType: '$',
          percentiles: {},
          calculatedPercentile: 0,
          errorMessage: 'Insufficient data to have an accurate calculation. We need the 25th, 50th, 55th, 60th, 65th 75th, 90th percentiles',
        },
      ],
    },
    {
      id: 204,
      name: 'Health Care Staff',
      year: 2023,
      region: 'National',
      calculations: [
        {
          variable: 'TCC - Hourly',
          incumbentCount: 2046,
          unitType: '$',
          percentiles: {
            10: 79726,
            25: 88525,
            50: 100173,
            55: 102003,
            60: 103730,
            65: 105498,
            75: 108971,
            90: 117083,
          },
          calculatedPercentile: 25.882,
        },
      ],
    },
  ],
}
